export function getNotificationText(notification, isAr) {
    const title = isAr
        ? (notification.title_ar || notification.title_en)
        : (notification.title_en || notification.title_ar);
    const body = isAr
        ? (notification.description_ar || notification.description_en)
        : (notification.description_en || notification.description_ar);
    return {
        title: title || (isAr ? 'إشعار' : 'Notification'),
        body: body || '',
    };
}
